import { useState } from 'react';
import { AdSlot, Size, TargetingArguments } from 'react-dfp';
import { AdsContainer, AdvertisementText } from './GoogleGAMAd.styles';

// All necessary AdSlot props for the Ad
interface Props {
  adUnit?: string;
  sizes?: Size[];
  targetingArguments?: TargetingArguments;
  slotId?: string;
}

export const GoogleGAMAd = ({ adUnit, slotId, sizes, targetingArguments }: Props) => {
  const [adRendered, setAdRendered] = useState(false);

  return (
    <AdsContainer>
      <AdSlot
        adUnit={adUnit}
        slotId={slotId}
        sizes={sizes}
        targetingArguments={targetingArguments}
        onSlotIsViewable={() => setAdRendered(true)}
      />
      {adRendered && <AdvertisementText />}
    </AdsContainer>
  );
};
